export default __webpack_public_path__ + "static/media/Bebedouro Acessivel.e9e0291b.svg";